import React from "react";
import { Link } from "react-router-dom";
import Hero from "./home/Hero";
import Featured from "./home/Featured";
import ProductGrid from "./home/ProductGrid";
import WhyBuySection from "./home/WhyBuySection";
import Vegetables from "./home/Vegetables";
import Banner from "./home/Banner";
import Bestseller from "./home/Bestseller";
import Fact from "./home/Fact";
import Testimonial from "./testimonial/Testimonial";
import SEO from "./SEO";

const Home = () => {
  return (
    <>
      <Hero />

      <SEO
        title="Shirts Patches"
        description="Shirts Patches"
        keywords="Shirts Patches"
      />

      <ProductGrid categoryId="all" categoryName="All Products" />

     <section className="relative mx-auto mt-8 max-w-7xl overflow-hidden rounded-[24px] border border-pastelPurple bg-white p-4 shadow-[0_12px_30px_rgba(47,34,84,0.08)] sm:p-5 md:p-6 lg:p-7">
  <div className="absolute left-0 top-0 h-56 w-56 rounded-full bg-pastelPurple/60 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 h-56 w-56 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative mx-auto max-w-6xl">
    <div className="grid gap-5 lg:grid-cols-[0.9fr_1.1fr] lg:items-stretch">
      {/* LEFT TITLE PANEL */}
      <div className="relative overflow-hidden rounded-[24px] bg-darkPurple p-5 text-white shadow-[0_14px_35px_rgba(47,34,84,0.16)] sm:p-6 lg:p-7">
        <div className="absolute -left-16 -top-16 h-48 w-48 rounded-full bg-pastelPurple/25 blur-3xl"></div>
        <div className="absolute -bottom-16 -right-16 h-48 w-48 rounded-full bg-keyLime/25 blur-3xl"></div>

        <div className="relative flex h-full flex-col justify-center">
          <h2 className="text-2xl font-extrabold leading-tight tracking-tight md:text-3xl lg:text-[34px]">
            Why Choose Our custom patches for shirts
          </h2>

          <div className="mt-4 flex items-center gap-3">
            <span className="h-1 w-14 rounded-full bg-keyLime"></span>
            <span className="h-1 w-7 rounded-full bg-pastelPurple"></span>
          </div>

          <p className="mt-5 text-base font-medium leading-7 text-[#f2ecff] md:text-lg md:leading-8">
            When it comes to quality and customization, our custom patches for
            shirts stand out from the rest. We focus on delivering patches that
            not only look great but also last through daily wear.
          </p>

          <div className="mt-6">
           
          </div>
        </div>
      </div>
    
      {/* RIGHT CONTENT PANEL */}
      <div className="relative overflow-hidden rounded-[24px] border border-pastelPurple bg-white p-5 shadow-[0_14px_35px_rgba(47,34,84,0.08)] sm:p-6 lg:p-7">
        <div className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-keyLime/20 blur-3xl"></div>
        <div className="absolute -left-20 -bottom-20 h-56 w-56 rounded-full bg-pastelPurple/45 blur-3xl"></div>

        <div className="relative">
          <p className="text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
            Our process is simple and efficient. As an experienced shirt patch
            maker, we help you at every step—from idea to final product. Whether
            you want to make your own shirts patches or choose from ready-made
            styles, we ensure top results every time.
          </p>

          <div className="mt-5 rounded-[22px] border border-pastelPurple bg-lightPastelPurple p-4">
            <ul className="grid gap-3">
              <h3 className="text-base font-semibold text-darkPurple">
                We use premium materials to create:
              </h3>

              <li className="flex gap-3 rounded-2xl border border-pastelPurple bg-white px-4 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
                Long-lasting custom shirt patches iron on
              </li>

              <li className="flex gap-3 rounded-2xl border border-pastelPurple bg-white px-4 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
                Detailed and creative shirt patches design
              </li>

              <li className="flex gap-3 rounded-2xl border border-pastelPurple bg-white px-4 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
                High-quality custom made patches for shirts
              </li>
            </ul>
          </div>

          <p className="mt-5 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
            If you're comparing shirts patches vs custom shirts patches, our
            custom solutions give you full control, better quality, and a more
            personalized finish.
          </p>

          <p className="mt-3 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
            Plus, you can easily order shirt patches online or in bulk with
            shirts patches wholesale no minimum, making us the perfect choice
            for individuals and businesses.
          </p>

          <div className="mt-6 flex flex-col gap-3 rounded-[22px] border border-pastelPurple bg-[#fbf9ff] p-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h4 className="text-base font-extrabold text-darkPurple">
                Ready to explore patch options?
              </h4>
              <p className="mt-1 text-sm font-medium leading-6 text-[#5f5870]">
                Browse all custom patch products and choose the best style for
                your shirts.
              </p>
            </div>

            <Link
              to="/products"
              className="inline-flex shrink-0 items-center justify-center rounded-2xl bg-darkPurple px-6 py-3 text-sm font-extrabold text-white shadow-[0_12px_26px_rgba(33,27,51,0.18)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-darkPurple"
            >
              View Products
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <Featured />

      <WhyBuySection />

      {/* <Vegetables /> */}
      {/* <Banner /> */}
      {/* <Bestseller />
      <Fact /> */}
      {/* <Testimonial /> */}
    </>
  );
};

export default Home;